// Eventi che arrivano da service-socket: il bus in src/store/socketEvents.ts li ripubblica
// dentro l'applicazione, così un solo componente tiene la connessione e chiunque può reagire.

/** Sorgenti degli eventi: il nome coincide con l'evento emesso dal backend */
export const SOCKET_EVENT_SOURCE = {
  ReportJob: "report-job",
  Notification: "notification",
} as const;

export type SocketEventSourceType =
  (typeof SOCKET_EVENT_SOURCE)[keyof typeof SOCKET_EVENT_SOURCE];

/**
 * Un evento ricevuto, con la sua provenienza. Il `payload` resta `unknown`: il bus non può
 * conoscere la forma di ogni sorgente, la restringe chi ascolta usando il tipo di dominio
 * (per i report: `ReportJobSocketPayloadType`).
 */
export interface SocketEventRecordType<T = unknown> {
  source: SocketEventSourceType;
  payload: T;
  /** progressivo: due eventi identici nel contenuto restano distinguibili */
  sequence: number;
  receivedAt: string;
}
